/**
 * Force the scroll container to the very top.
 *
 * Important: this app's real scroll container is `#root`, not `window` (see
 * `index.css`: `html, body, #root { height: 100%; overflow-x: hidden }` — the
 * `#root` div becomes the y-scroller). So `window.scrollTo(0,0)` alone is a
 * silent no-op inside SPA navigations. This helper resets ALL of them.
 *
 * Also runs on rAF twice to defeat React.lazy Suspense chunks + late image
 * loads pushing the scroll position back down as the new page paints.
 */
export function scrollToPageTop() {
  if (typeof window === "undefined") return;
  const html = document.documentElement;
  const root = document.getElementById("root");
  const prevBehavior = html.style.scrollBehavior;
  html.style.scrollBehavior = "auto";
  const jump = () => {
    try { window.scrollTo(0, 0); } catch (_e) { /* ignore */ }
    try { html.scrollTop = 0; document.body.scrollTop = 0; } catch (_e) { /* ignore */ }
    if (root) root.scrollTop = 0;
  };
  jump();
  requestAnimationFrame(() => {
    jump();
    requestAnimationFrame(() => {
      jump();
      html.style.scrollBehavior = prevBehavior;
    });
  });
}
